// Common temporary/disposable email domains to block
const TEMP_EMAIL_DOMAINS = [
  // 10 minute mail
  '10minutemail.com',
  '10minutemail.net',
  '10minutemail.org',
  
  // Guerrilla mail
  'guerrillamail.com',
  'guerrillamail.net',
  'guerrillamail.org',
  'guerrillamail.biz',
  'guerrillamail.de',
  'grr.la',
  'guerrillamailblock.com',
  
  // Mailinator
  'mailinator.com',
  'mailinator.net',
  'mailinator.org',
  
  // TempMail
  'temp-mail.org',
  'tempmail.net',
  'tempmail.com',
  'tempmailer.com',
  'tempmailer.de',
  
  // Throwaway email
  'throwaway.email',
  'throwawaymailbox.com',
  
  // Other popular temp email services
  'yopmail.com',
  'yopmail.fr',
  'yopmail.net',
  'cool.fr.nf',
  'jetable.fr.nf',
  'noclickemail.com',
  'mega.zik.dj',
  'speed.1s.fr',
  'courriel.fr.nf',
  'moncourrier.fr.nf',
  'monemail.fr.nf',
  'monmail.fr.nf',
  'hide.biz.st',
  'mymail.infos.st',
  
  // Maildrop
  'maildrop.cc',
  
  // Sharklasers
  'sharklasers.com',
  
  // Fakeinbox
  'fakeinbox.com',
  
  // Spamgourmet
  'spamgourmet.com',
  'spamgourmet.net',
  'spamgourmet.org',
  
  // Dispostable
  'dispostable.com',
  
  // Emailondeck
  'emailondeck.com',
  
  // Mohmal
  'mohmal.com',
  
  // GetNada
  'getnada.com',
  
  // Disposable email
  'disposable.debconf.org',
  
  // Blur/Abine
  'abine.com',
  
  // 33mail
  '33mail.com',
  
  // AirMail
  'airmail.cc',
  
  // Anonymous
  'anonymbox.com',
  
  // Burner mail
  'burnermail.io',
  
  // Cock.li
  'cock.li',
  
  // CrapThatEmail
  'crapthatmail.com',
  
  // CuirTir
  'cuirTir.com',
  
  // Deadaddress
  'deadaddress.com',
  
  // Despam
  'despam.it',
  
  // DevNull
  'devnullmail.com',
  
  // Disposablemail
  'disposablemail.com',
  
  // DumpMail
  'dumpmail.de',
  
  // EmailLater
  'emaillater.com',
  
  // Gishpuppy
  'gishpuppy.com',
  
  // Harakirimail
  'harakirimail.com',
  
  // Incognitomail
  'incognitomail.org',
  
  // Jetable
  'jetable.org',
  
  // Klzlk
  'klzlk.com',
  
  // Mail-temporaire
  'mail-temporaire.fr',
  
  // Mailcatch
  'mailcatch.com',
  
  // Maileater
  'maileater.com',
  
  // Mailexpire
  'mailexpire.com',
  
  // Mailin8r
  'mailin8r.com',
  
  // Mailmetrash
  'mailmetrash.com',
  
  // Mailnull
  'mailnull.com',
  
  // Mailscrap
  'mailscrap.com',
  
  // Mailtothis
  'mailtothis.com',
  
  // Mintemail
  'mintemail.com',
  
  // Mytrashmail
  'mytrashmail.com',
  
  // No-spam
  'no-spam.ws',
  
  // Objectmail
  'objectmail.com',
  
  // OneoffMail
  'oneoffmail.com',
  
  // Pookmail
  'pookmail.com',
  
  // Proxymail
  'proxymail.eu',
  
  // Rcpt
  'rcpt.at',
  
  // Recode
  'recode.me',
  
  // S0ny
  's0ny.net',
  
  // Safe-mail
  'safe-mail.net',
  
  // Selfdestructingemail
  'selfdestructingemail.com',
  
  // Sendspamhere
  'sendspamhere.com',
  
  // Spambox
  'spambox.us',
  
  // Spamfree24
  'spamfree24.org',
  
  // Spamhole
  'spamhole.com',
  
  // Spamify
  'spamify.com',
  
  // Spammotel
  'spammotel.com',
  
  // Spamspot
  'spamspot.com',
  
  // Spamthis
  'spamthis.co.uk',
  
  // Tempemail
  'tempemail.com',
  
  // Tempinbox
  'tempinbox.com',
  
  // Temporaryemail
  'temporaryemail.us',
  
  // Temporaryforwarding
  'temporaryforwarding.com',
  
  // Temporaryinbox
  'temporaryinbox.com',
  
  // Thanksnospam
  'thanksnospam.info',
  
  // Trash-amil
  'trash-amil.com',
  
  // Trashdevil
  'trashdevil.com',
  
  // Trashmail
  'trashmail.net',
  'trashmail.org',
  'trashmail.ws',
  
  // Wegwerfmail
  'wegwerfmail.de',
  'wegwerfmail.net',
  'wegwerfmail.org',
  
  // Wetrainbayarea
  'wetrainbayarea.com',
  
  // Yuurok
  'yuurok.com',
  
  // Zehnminutenmail
  'zehnminutenmail.de',
  
  // Additional common ones
  'mailforspam.com',
  'tempmail.de',
  'discard.email',
  'spamhereplease.com',
  'tempymail.com',
  'anonmails.de',
  'byom.de',
  'trashmailer.com',
  'kurzepost.de',
  'objectmail.com',
  'proxymail.eu',
  'rcpt.at',
  'trash2009.com',
  'trashmail.at',
  'trashmail.com',
  'trashmail.io',
  'trashmail.me',
  'wegwerfemail.de',
  'spam4.me',
  'meinspamschutz.de',
  'lobaltrash.com',
  'moakt.com',
  'spambog.com',
  'spambog.de',
  'spambog.ru',
  'spammotel.com',
  'spammotel.de',
  'spamstack.net',
  'speed.1s.fr',
  '0-mail.com',
  '027168.com',
  '10mail.org',
  '123-m.com',
  '1chuan.com',
  '1mail.ml',
  '20email.eu',
  '20mail.it',
  '2prong.com',
  '30minutemail.com',
  '33mail.com',
  '3d-painting.com',
  '4mail.cf',
  '4warding.com',
  '60minutemail.com',
  '675hosting.com',
  '675hosting.net',
  '675hosting.org',
  '7tags.com',
  '9ox.net',
  'a-bc.net',
  'afrobacon.com',
  'ajaxapp.net',
  'ama-trade.de',
  'amilegit.com',
  'amiri.net',
  'amiriindustrial.com',
  'anonbox.net',
  'antichef.com',
  'antichef.net',
  'antireg.ru',
  'antispam.de',
  'antispammail.de',
  'appixie.com',
  'armyspy.com',
  'artman-conception.com',
  'azmeil.tk',
  'baxomale.ht.cx',
  'beddly.com',
  'beefmilk.com',
  'bigprofessor.so',
  'bigstring.com',
  'binkmail.com',
  'bio-muesli.net',
  'bobmail.info',
  'bodhi.lawlita.com',
  'bofthew.com',
  'bootybay.de',
  'boun.cr',
  'bouncr.com',
  'boxformail.in',
  'brefmail.com',
  'brennendesreich.de',
  'broadbandninja.com',
  'bspamfree.org',
  'bugmenot.com',
  'bumpymail.com',
  'bundes-li.ga',
  'buymoreplays.com',
  'byom.de',
  'c2.hu',
  'cachedot.net',
  'card.zp.ua',
  'casualdx.com',
  'cbenpm.com',
  'cc.liamria',
  'cdnqa.com',
  'centermail.com',
  'centermail.net',
  'chammy.info',
  'childsavetoys.com',
  'chogmail.com',
  'choicemail1.com',
  'clixser.com',
  'cmail.com',
  'cmail.net',
  'cmail.org',
  'coldemail.info',
  'cool.fr.nf',
  'correo.blogos.net',
  'cosmorph.com',
  'courriel.fr.nf',
  'courrieltemporaire.com',
  'crapmail.org',
  'cust.in',
  'dacoolest.com',
  'dandikmail.com',
  'dayrep.com',
  'dbunker.com',
  'dcemail.com',
  'deadchildren.org',
  'deadfake.cf',
  'deadfake.ga',
  'deadfake.ml',
  'deadfake.tk',
  'deadspam.com',
  'delikkt.de',
  'despammed.com',
  'devnullmail.com',
  'dfgh.net',
  'digitalsanctuary.com',
  'dingbone.com',
  'disposableaddress.com',
  'disposableemailaddresses.com',
  'disposableinbox.com',
  'dispose.it',
  'disposeamail.com',
  'disposemail.com',
  'dispostable.com',
  'dm.origin8.org',
  'dodgeit.com',
  'dodgit.com',
  'donemail.ru',
  'dontreg.com',
  'dontsendmespam.de',
  'drdrb.net',
  'dump-email.info',
  'dumpandjunk.com',
  'dumpyemail.com',
  'e4ward.com',
  'easytrashmail.com',
  'einrot.com',
  'email60.com',
  'emaildienst.de',
  'emailgo.de',
  'emailias.com',
  'emailinfive.com',
  'emailisvalid.com',
  'emailmiser.com',
  'emailsensei.com',
  'emailtemporar.ro',
  'emailtemporario.com.br',
  'emailthe.net',
  'emailtmp.com',
  'emailto.de',
  'emailwarden.com',
  'emailx.at.hm',
  'emailxfer.com',
  'emz.net',
  'enterto.com',
  'ephemail.net',
  'est.une.victime.ninja',
  'etranquil.com',
  'etranquil.net',
  'etranquil.org',
  'evopo.com',
  'explodemail.com',
  'extremail.ru',
  'eyepaste.com',
  'facebook-email.cf',
  'facebook-email.ga',
  'facebook-email.ml',
  'fakedemail.com',
  'fakeinformation.com',
  'fakemail.fr',
  'fakemailgenerator.com',
  'fakemailz.com',
  'fammix.com',
  'fansworldwide.de',
  'fantasymail.de',
  'fastacura.com',
  'fastchevy.com',
  'fastchrysler.com',
  'fastkawasaki.com',
  'fastmazda.com',
  'fastmitsubishi.com',
  'fastnissan.com',
  'fastsubaru.com',
  'fastsuzuki.com',
  'fasttoyota.com',
  'fastyamaha.com',
  'fatflap.com',
  'fdfdsfds.com',
  'ficken.de',
  'filzmail.com',
  'fivemail.de',
  'fixmail.tk',
  'fizmail.com',
  'fleckens.hu',
  'flyspam.com',
  'footard.com',
  'forgetmail.com',
  'fr33mail.info',
  'frapmail.com',
  'friendlymail.co.uk',
  'fudgerub.com',
  'fux0ringduh.com',
  'garliclife.com',
  'gelitik.in',
  'get-mail.cf',
  'get-mail.ga',
  'get-mail.ml',
  'get-mail.tk',
  'get1mail.com',
  'getairmail.cf',
  'getairmail.com',
  'getairmail.ga',
  'getairmail.gq',
  'getairmail.ml',
  'getairmail.tk',
  'getmails.eu',
  'getonemail.com',
  'getonemail.net',
  'ghosttexter.de',
  'girlsundertheinfluence.com',
  'gishpuppy.com',
  'gmial.com',
  'goemailgo.com',
  'gotmail.cf',
  'gotmail.ga',
  'gotmail.ml',
  'gotmail.tk',
  'gotti.otherinbox.com',
  'great-host.in',
  'greensloth.com',
  'grr.la',
  'gsrv.co.uk',
  'guerillamail.biz',
  'guerillamail.com',
  'guerillamail.de',
  'guerillamail.net',
  'guerillamail.org',
  'guerillamailblock.com',
  'guerrillamail.biz',
  'guerrillamail.com',
  'guerrillamail.de',
  'guerrillamail.info',
  'guerrillamail.net',
  'guerrillamail.org',
  'guerrillamailblock.com',
  'h.mintemail.com',
  'harakirimail.com',
  'hartbot.de',
  'hat-geld.de',
  'hatespam.org',
  'heilbronner-voice.de',
  'herp.in',
  'hidemail.de',
  'hidzz.com',
  'hmamail.com',
  'hopemail.biz',
  'hot-mail.cf',
  'hot-mail.ga',
  'hot-mail.gq',
  'hot-mail.ml',
  'hot-mail.tk',
  'hotpop.com',
  'hulapla.de',
  'ieatspam.eu',
  'ieatspam.info',
  'ieh-mail.de',
  'ikbenspamvrij.nl',
  'imails.info',
  'inboxalias.com',
  'inboxclean.com',
  'inboxclean.org',
  'incognitomail.com',
  'incognitomail.net',
  'incognitomail.org',
  'insorg-mail.info',
  'instant-mail.de',
  'ip6.li',
  'irish2me.com',
  'iwi.net',
  'jafps.com',
  'jasons.tk',
  'jnxjn.com',
  'jourrapide.com',
  'jsrsolutions.com',
  'junk1e.com',
  'kasmail.com',
  'kaspop.com',
  'keepmymail.com',
  'killmail.com',
  'killmail.net',
  'kingsq.ga',
  'klzlk.com',
  'kook.ml',
  'koszmail.pl',
  'kurzepost.de',
  'l33r.eu',
  'labetteraverouge.at',
  'lackmail.net',
  'lags.us',
  'landmail.co',
  'lastmail.co',
  'lavabit.com',
  'letthemeatspam.com',
  'lhsdv.com',
  'lifebyfood.com',
  'link2mail.net',
  'litedrop.com',
  'loadby.us',
  'login-email.cf',
  'login-email.ga',
  'login-email.ml',
  'login-email.tk',
  'lol.ovpn.to',
  'lolfreak.net',
  'lookugly.com',
  'lopl.co.cc',
  'lortemail.dk',
  'lr78.com',
  'lroid.com',
  'lukop.dk',
  'm21.cc',
  'mail-filter.com',
  'mail-temporaire.fr',
  'mail.by',
  'mail.mezimages.net',
  'mail2rss.org',
  'mail333.com',
  'mail4trash.com',
  'mailbidon.com',
  'mailblocks.com',
  'mailbucket.org',
  'mailcat.biz',
  'mailcatch.com',
  'mailde.de',
  'mailde.info',
  'maildrop.cc',
  'maildu.de',
  'maileater.com',
  'mailed.ro',
  'maileimer.de',
  'mailexpire.com',
  'mailfa.tk',
  'mailforspam.com',
  'mailfreeonline.com',
  'mailguard.me',
  'mailimate.com',
  'mailin8r.com',
  'mailinater.com',
  'mailinator.com',
  'mailinator.net',
  'mailinator.org',
  'mailinator2.com',
  'mailincubator.com',
  'mailismagic.com',
  'mailjunk.cf',
  'mailjunk.ga',
  'mailjunk.gq',
  'mailjunk.ml',
  'mailjunk.tk',
  'mailme.gq',
  'mailme.ir',
  'mailmetrash.com',
  'mailmoat.com',
  'mailms.com',
  'mailnator.com',
  'mailnesia.com',
  'mailnull.com',
  'mailorg.org',
  'mailpick.biz',
  'mailrock.biz',
  'mailscrap.com',
  'mailshell.com',
  'mailsiphon.com',
  'mailtemp.info',
  'mailtome.de',
  'mailtothis.com',
  'mailtrash.net',
  'mailtv.net',
  'mailtv.tv',
  'mailzilla.com',
  'mailzilla.org',
  'makemetheking.com',
  'manifestgenerator.com',
  'manybrain.com',
  'mbx.cc',
  'mciek.com',
  'mega.zik.dj',
  'meinspamschutz.de',
  'meltmail.com',
  'messagebeamer.de',
  'mezimages.net',
  'mierdamail.com',
  'migmail.pl',
  'mintemail.com',
  'mjukglass.nu',
  'mobi.web.id',
  'mobileninja.co.uk',
  'moburl.com',
  'moncourrier.fr.nf',
  'monemail.fr.nf',
  'monmail.fr.nf',
  'monumentmail.com',
  'mt2009.com',
  'mt2014.com',
  'mycard.net.ua',
  'mycleaninbox.net',
  'mymail.infos.st',
  'mypacks.net',
  'mypartyclip.de',
  'myphantomemail.com',
  'myspaceinc.com',
  'myspaceinc.net',
  'myspaceinc.org',
  'myspacepimpedup.com',
  'myspamless.com',
  'mytrashmail.com',
  'neomailbox.com',
  'nepwk.com',
  'nervmich.net',
  'nervtmich.net',
  'netmails.com',
  'netmails.net',
  'neverbox.com',
  'nice-4u.com',
  'nincsmail.hu',
  'nnh.com',
  'no-spam.ws',
  'nobulk.com',
  'noclickemail.com',
  'nogmailspam.info',
  'nomail.xl.cx',
  'nomail2me.com',
  'nomorespamemails.com',
  'nonspam.eu',
  'nonspammer.de',
  'noref.in',
  'nospam.ze.tc',
  'nospam4.us',
  'nospamfor.us',
  'nospammail.net',
  'nospamthanks.info',
  'notmailinator.com',
  'nowmymail.com',
  'nurfuerspam.de',
  'nwldx.com',
  'objectmail.com',
  'obobbo.com',
  'odaymail.com',
  'oneoffemail.com',
  'onewaymail.com',
  'onlatedotcom.info',
  'online.ms',
  'oopi.org',
  'opayq.com',
  'ordinaryamerican.net',
  'otherinbox.com',
  'ovpn.to',
  'owlpic.com',
  'pazml.com',
  'pjkolutions.com',
  'plexolan.de',
  'poczta.onet.pl',
  'politikerclub.de',
  'pooae.com',
  'pookmail.com',
  'privacy.net',
  'privatdemail.net',
  'proxymail.eu',
  'prtnx.com',
  'putthisinyourspamdatabase.com',
  'pwrby.com',
  'qisdo.com',
  'qisoa.com',
  'qoika.com',
  'qs.dp.ua',
  'quickinbox.com',
  'rcpt.at',
  're-gister.com',
  'readmailhere.com',
  'recode.me',
  'reconmail.com',
  'recursor.net',
  'regbypass.comsafe-mail.net',
  'rejectmail.com',
  'rhyta.com',
  'rklips.com',
  'rmqkr.net',
  'royal.net',
  'rppkn.com',
  'rtrtr.com',
  's0ny.net',
  'safe-mail.net',
  'safersignup.de',
  'safetymail.info',
  'safetypost.de',
  'sandelf.de',
  'saynotospams.com',
  'scatmail.com',
  'schafmail.de',
  'schrott-email.de',
  'secretemail.de',
  'secure-mail.biz',
  'selfdestructingemail.com',
  'selfdestructingmail.com',
  'sendspamhere.com',
  'sharklasers.com',
  'shieldedmail.com',
  'shitmail.me',
  'shitware.nl',
  'shmeriously.com',
  'shortmail.net',
  'sibmail.com',
  'sify.com',
  'sina.com',
  'sinnlos-mail.de',
  'siteposter.net',
  'skeefmail.com',
  'slaskpost.se',
  'slopsbox.com',
  'smashmail.de',
  'smellfear.com',
  'snakemail.com',
  'snkmail.com',
  'sofimail.com',
  'solvemail.info',
  'sogetthis.com',
  'soodonims.com',
  'spam.la',
  'spam.su',
  'spam4.me',
  'spamail.de',
  'spambob.com',
  'spambog.com',
  'spambog.de',
  'spambog.net',
  'spambog.ru',
  'spambox.info',
  'spambox.irishspringtours.com',
  'spambox.us',
  'spamcannon.com',
  'spamcannon.net',
  'spamcero.com',
  'spamcon.org',
  'spamcorptastic.com',
  'spamcowboy.com',
  'spamcowboy.net',
  'spamcowboy.org',
  'spamday.com',
  'spamex.com',
  'spamfree.eu',
  'spamfree24.com',
  'spamfree24.de',
  'spamfree24.eu',
  'spamfree24.info',
  'spamfree24.net',
  'spamfree24.org',
  'spamgoes.com',
  'spamgourmet.com',
  'spamgourmet.net',
  'spamgourmet.org',
  'spamherelots.com',
  'spamhereplease.com',
  'spamhole.com',
  'spami.spam.poisonedwater.org',
  'spamify.com',
  'spaminator.de',
  'spamkill.info',
  'spaml.com',
  'spaml.de',
  'spammotel.com',
  'spammotel.de',
  'spamobox.com',
  'spamoff.de',
  'spamslicer.com',
  'spamspot.com',
  'spamstack.net',
  'spamthis.co.uk',
  'spamtroll.net',
  'speed.1s.fr',
  'spoofmail.de',
  'stuffmail.de',
  'super-auswahl.de',
  'supergreatmail.com',
  'supermailer.jp',
  'superrito.com',
  'superstachel.de',
  'suremail.info',
  'talkinator.com',
  'teewars.org',
  'teleworm.com',
  'teleworm.us',
  'temp-mail.org',
  'temp-mail.ru',
  'tempail.com',
  'tempalias.com',
  'tempe-mail.com',
  'tempemail.biz',
  'tempemail.com',
  'tempinbox.co.uk',
  'tempinbox.com',
  'tempmail.eu',
  'tempmailer.com',
  'tempmailer.de',
  'tempomail.fr',
  'temporarily.de',
  'temporarioemail.com.br',
  'temporaryemail.net',
  'temporaryemail.us',
  'temporaryforwarding.com',
  'temporaryinbox.com',
  'temporarymailaddress.com',
  'tempsky.com',
  'tempymail.com',
  'testudine.com',
  'thankyou2010.com',
  'thecloudindex.com',
  'thisisnotmyrealemail.com',
  'thismail.net',
  'throam.com',
  'throwawayemailaddresses.com',
  'tilien.com',
  'tittbit.in',
  'tmail.ws',
  'tmailinator.com',
  'toomail.biz',
  'topranklist.de',
  'tradermail.info',
  'trash-amil.com',
  'trash-mail.at',
  'trash-mail.com',
  'trash-mail.de',
  'trash2009.com',
  'trashdevil.com',
  'trashdevil.de',
  'trashemail.de',
  'trashmail.at',
  'trashmail.com',
  'trashmail.de',
  'trashmail.me',
  'trashmail.net',
  'trashmail.org',
  'trashmail.ws',
  'trashmailer.com',
  'trashymail.com',
  'trashymail.net',
  'trialmail.de',
  'trillianpro.com',
  'tryalert.com',
  'turual.com',
  'twinmail.de',
  'twoweirdtricks.com',
  'txtadvertise.com',
  'uggsrock.com',
  'unemployment-blog.com',
  'unmail.ru',
  'upliftnow.com',
  'uplipht.com',
  'uroid.com',
  'us.af',
  'venompen.com',
  'veryrealemail.com',
  'viditag.com',
  'viewcastmedia.com',
  'viewcastmedia.net',
  'viewcastmedia.org',
  'vomoto.com',
  'vpn.st',
  'vsimcard.com',
  'vubby.com',
  'wasteland.rfc822.org',
  'webemail.me',
  'webm4il.info',
  'weg-werf-email.de',
  'wegwerf-emails.de',
  'wegwerfadresse.de',
  'wegwerfemail.com',
  'wegwerfemail.de',
  'wegwerfmail.de',
  'wegwerfmail.info',
  'wegwerfmail.net',
  'wegwerfmail.org',
  'wetrainbayarea.com',
  'wetrainbayarea.org',
  'wh4f.org',
  'whatpaas.com',
  'whyspam.me',
  'willhackforfood.biz',
  'willselldrugs.com',
  'wuzup.net',
  'wuzupmail.net',
  'www.e4ward.com',
  'www.gishpuppy.com',
  'www.mailinator.com',
  'xagloo.com',
  'xemaps.com',
  'xents.com',
  'xmail.com',
  'xmaily.com',
  'xoxy.net',
  'yanet.me',
  'yapped.net',
  'yeah.net',
  'yep.it',
  'yogamaven.com',
  'yomail.info',
  'yopmail.com',
  'yopmail.fr',
  'yopmail.net',
  'youmailr.com',
  'yourdomain.com',
  'ypmail.webredirect.org',
  'yuurok.com',
  'zehnminuten-mail.de',
  'zehnminutenmail.de',
  'zetmail.com',
  'zoemail.net',
  'zoemail.org',
  'zomg.info'
];

export function isTemporaryEmail(email: string): boolean {
  const emailLower = email.toLowerCase();
  const domain = emailLower.split('@')[1];
  
  if (!domain) return false;
  
  return TEMP_EMAIL_DOMAINS.includes(domain);
}

export function getEmailValidationError(email: string): string | null {
  if (!email) return 'Email is required';
  
  // Basic email format validation
  const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
  if (!emailRegex.test(email)) {
    return 'Please enter a valid email address';
  }
  
  // Check for temporary email domains
  if (isTemporaryEmail(email)) {
    return 'Temporary and disposable email addresses are not allowed. Please use a permanent email address.';
  }
  
  return null;
}
